import { render, staticRenderFns } from "./SynastryInterpret.vue?vue&type=template&id=f688acec&scoped=true&"
import script from "./SynastryInterpret.vue?vue&type=script&lang=js&"
export * from "./SynastryInterpret.vue?vue&type=script&lang=js&"
import style0 from "./SynastryInterpret.vue?vue&type=style&index=0&id=f688acec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f688acec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f688acec')) {
      api.createRecord('f688acec', component.options)
    } else {
      api.reload('f688acec', component.options)
    }
    module.hot.accept("./SynastryInterpret.vue?vue&type=template&id=f688acec&scoped=true&", function () {
      api.rerender('f688acec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/雙人合盤/SynastryInterpret.vue"
export default component.exports